import { TFunction } from 'i18next'

type DisplayedRowsParams = {
  from: number
  to: number
  count: number
}

export const getTablePaginationDisplayedRows =
  (t: TFunction) =>
  ({ from, to, count }: DisplayedRowsParams) =>
    count === -1
      ? t('tablePagination.displayedRowsUnknown', '{{from}}-{{to}} of more than {{to}}', {
          from,
          to,
        })
      : t('tablePagination.displayedRows', '{{from}}-{{to}} of {{count}}', {
          from,
          to,
          count,
        })
